import { render, staticRenderFns } from "./scene8.vue?vue&type=template&id=160e90a6&scoped=true&"
import script from "./scene8.vue?vue&type=script&lang=ts&"
export * from "./scene8.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e90a6",
  null
  
)

export default component.exports